import { sortAlphabetically } from "../components/admin/helper/formatters";
import { IBigscreenSettings, IEventField } from "../constants/interfaces";

export function computeEventFields(bigscreenSettings: IBigscreenSettings[]): IEventField[] {
    const allEvents = bigscreenSettings.flatMap(brand => brand.segments || []);
    const eventFields = allEvents.reduce((arr: IEventField[], item) => {
        item.components.forEach(component => {
            const segmentValue = component.isNot ? `mustNot|${component.value}` : component.value;

            arr.push({
                brand_id: item.brandId,
                name: `${item.brandId}--${item.segmentId}--${segmentValue}`,
                label: `${item.brandName} - ${item.segmentName}: ${component.label}`,
                short_label: component.label
            });
        });


        return arr;
    }, []);

    return sortAlphabetically(eventFields, 'label');
}

export default computeEventFields;
